import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { SmartLink } from "../SmartLink";
import axios from "axios";
import { SponsorBanner } from "../SponsorBanner";
import { LOGO_URL } from "../../data/content";

const API = `${window.__BACKEND__}/api`;
const BRIC = "'Bricolage Grotesque', system-ui, sans-serif";
const FAQBNB_IMG = "https://customer-assets.emergentagent.com/job_vita-portal/artifacts/2v62obec_NUOVA%20ICONA%20FAQBNB.png";
const HOSTCLUB_IMG = "https://customer-assets-m6fa6gv7.emergentagent.net/job_vita-portal/artifacts/8djekz63_HOSTCLUB%20QUADRATO.webp";

function Box({ children, title, headerRight, className = "", style = {}, ...rest }) {
  if (title !== undefined) {
    return (
      <div className="rounded-[20px] overflow-hidden flex flex-col" style={{ background: "#FFFFFF", border: "1px solid #E4E6EA", ...style }} {...rest}>
        <div className="flex items-center justify-between gap-3 px-5 py-3" style={{ background: "#FFC233" }}>
          <strong className="text-[16px]" style={{ color: "#111318" }}>{title}</strong>
          {headerRight}
        </div>
        <div className={`p-5 pt-4 flex flex-col gap-2.5 ${className}`}>{children}</div>
      </div>
    );
  }
  return (
    <div className={`rounded-[20px] p-5 flex flex-col gap-2.5 ${className}`} style={{ background: "#FFFFFF", border: "1px solid #E4E6EA", ...style }} {...rest}>
      {children}
    </div>
  );
}

// ─── App ufficiale ───
function AppleGlyph({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M16.365 1.43c0 1.14-.42 2.2-1.12 3-.76.88-2 1.56-3.03 1.48-.13-1.09.42-2.26 1.08-3 .74-.84 2.05-1.46 3.07-1.48zM20.6 17.03c-.56 1.3-.83 1.87-1.55 3.02-1 1.6-2.42 3.6-4.17 3.61-1.56.02-1.96-1.02-4.07-1.01-2.11.01-2.55 1.03-4.11 1.01-1.75-.02-3.09-1.82-4.09-3.42C-.07 17.36-.3 12.3 1.4 9.55c1.21-1.95 3.12-3.09 4.92-3.09 1.83 0 2.98 1.01 4.49 1.01 1.47 0 2.36-1.01 4.48-1.01 1.6 0 3.3.87 4.5 2.38-3.96 2.17-3.32 7.82.81 8.19z" />
    </svg>
  );
}
function AndroidGlyph({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M17.6 9.48l1.84-3.18a.38.38 0 0 0-.14-.52.38.38 0 0 0-.52.14l-1.86 3.22a11.38 11.38 0 0 0-8.84 0L6.22 5.92a.38.38 0 0 0-.52-.14.38.38 0 0 0-.14.52L7.4 9.48A10.78 10.78 0 0 0 2 18.5h20a10.78 10.78 0 0 0-5.4-9.02M7 15.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2m10 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2" />
    </svg>
  );
}
function AppUfficiale() {
  return (
    <Box title="Scarica l'app ufficiale" data-testid="aside-app-ufficiale" className="!gap-3">
      <div className="grid grid-cols-2 gap-2">
        <a href="https://apps.apple.com/it/app/vita-da-host/id6760694341" target="_blank" rel="noopener noreferrer" data-testid="aside-app-ios" className="h-12 rounded-[12px] flex items-center justify-center gap-2 font-bold text-[14px]" style={{ background: "#111318", color: "#FFFFFF" }}>
          <AppleGlyph size={16} /> App Store
        </a>
        <a href="https://play.google.com/store/apps/details?id=com.wnapp.id1778937032200&pcampaignid=web_share" target="_blank" rel="noopener noreferrer" data-testid="aside-app-android" className="h-12 rounded-[12px] flex items-center justify-center gap-2 font-bold text-[14px]" style={{ background: "#1DB954", color: "#FFFFFF" }}>
          <AndroidGlyph size={18} /> Google Play
        </a>
      </div>
      <span className="text-[13px]" style={{ color: "#5B616C" }}>Disponibile anche per Mac e Windows</span>
    </Box>
  );
}

// ─── Prossimi eventi ───
function parseDate(d) { const x = new Date(d); return isNaN(x) ? null : x; }
const MESI = ["GEN", "FEB", "MAR", "APR", "MAG", "GIU", "LUG", "AGO", "SET", "OTT", "NOV", "DIC"];
const FALLBACK_EVENTS = [
  { day: "13", month: "OTT", title: "Hospitality Day", location: "Rimini, PalaCongressi" },
  { day: "14", month: "OTT", title: "TTG 2026", location: "Rimini Fiera" },
  { day: "23", month: "OTT", title: "Condominio Experience", location: "Roma, Palazzo WeGil" },
  { day: "26", month: "OTT", title: "Stati Generali Affitti Brevi", location: "Milano, Teatro Nazionale" },
  { day: "09", month: "NOV", title: "Property Days", location: "Mestre, M9 Museo del 900" },
  { day: "17", month: "NOV", title: "Vivere di Turismo Festival · −20%", location: "Rimini, PalaCongressi" },
];
function ProssimiEventi() {
  const [events, setEvents] = useState([]);
  useEffect(() => {
    let alive = true;
    axios.get(`${API}/events`, { params: { upcoming_only: true, limit: 6 } })
      .then((r) => { if (alive) setEvents((r.data?.items || r.data || []).slice(0, 6)); }).catch(() => {});
    return () => { alive = false; };
  }, []);
  const rows = events.length
    ? events.map((ev, i) => {
        const d = parseDate(ev.date);
        return { day: d ? String(d.getDate()).padStart(2, "0") : "--", month: d ? MESI[d.getMonth()] : "", title: ev.title, location: ev.location, to: `/eventi/${ev.slug || ev.id}` };
      })
    : FALLBACK_EVENTS.map((e) => ({ ...e, to: "/eventi" }));
  return (
    <Box title="Prossimi eventi" headerRight={<Link to="/eventi" className="text-[14px] font-bold" style={{ color: "#111318" }}>Tutti →</Link>} data-testid="aside-eventi" className="!gap-3">
      {rows.map((ev, i) => (
        <Link key={i} to={ev.to} className="flex gap-3 items-center">
          <span className="w-[52px] flex-none text-center rounded-[12px] py-1.5" style={{ background: "#F1F2F4", lineHeight: 1.1 }}>
            <strong className="text-[18px] block" style={{ color: "#111318" }}>{ev.day}</strong>
            <span className="text-[11px] font-extrabold" style={{ color: "#111318" }}>{ev.month}</span>
          </span>
          <span className="flex flex-col min-w-0">
            <strong className="text-[15px]" style={{ color: "#111318" }}>{ev.title}</strong>
            <span className="text-[13px]" style={{ color: "#4A505B" }}>{ev.location}</span>
          </span>
        </Link>
      ))}
    </Box>
  );
}

// ─── Newsletter FaqBnb ───
function NewsletterFaqBnb() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle");
  const [count, setCount] = useState(null);
  const [dl, setDl] = useState("");
  useEffect(() => {
    let alive = true;
    axios.get(`${API}/promo/faqbnb-free/count`).then((r) => { if (alive) setCount(r.data?.count ?? null); }).catch(() => {});
    return () => { alive = false; };
  }, []);
  const submit = async (e) => {
    e.preventDefault();
    if (!email.includes("@")) return;
    setStatus("sending");
    try {
      const r = await axios.post(`${API}/promo/faqbnb-free`, { email: email.trim().toLowerCase(), name: "" });
      setDl(r.data?.download_url || "");
      setStatus("done");
      if (r.data?.download_url) setTimeout(() => window.open(r.data.download_url, "_blank"), 400);
    } catch { setStatus("error"); }
  };
  return (
    <div className="rounded-[20px] p-[22px] flex flex-col gap-3" style={{ background: "#EA580C" }} data-testid="aside-newsletter">
      <img src={FAQBNB_IMG} alt="Copertina di FaqBnb 2026, il manuale di Vita da Host" loading="lazy"
        className="block object-cover" style={{ width: "calc(100% + 44px)", maxWidth: "none", margin: "-22px -22px 0", aspectRatio: "1", borderRadius: "20px 20px 0 0" }} />
      <strong style={{ fontFamily: BRIC, fontSize: 24, lineHeight: 1.15, color: "#111318" }}>FaqBnb 2026 gratis</strong>
      <span className="text-[15px]" style={{ lineHeight: 1.5, color: "#111318" }}>Il manuale di 60 pagine di Sergio Battelli, iscriviti alla newsletter per averlo in regalo.</span>
      {status === "done" ? (
        <a href={dl} target="_blank" rel="noopener noreferrer" className="h-12 rounded-[12px] flex items-center justify-center font-extrabold" style={{ background: "#111318", color: "#FFFFFF", WebkitTextFillColor: "#FFFFFF" }} data-testid="aside-newsletter-download">
          Scarica FaqBnb 2026 ↓
        </a>
      ) : (
        <form onSubmit={submit} className="flex flex-col gap-2">
          <label htmlFor="nl-faqbnb" className="text-[13px] font-bold" style={{ color: "#111318" }}>La tua email</label>
          <input id="nl-faqbnb" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="nome@email.it"
            className="h-12 rounded-[12px] px-3.5 outline-none" style={{ border: 0 }} data-testid="aside-newsletter-email" />
          <button type="submit" disabled={status === "sending"} className="h-12 rounded-[12px] font-extrabold" style={{ background: "#111318", color: "#FFC233", WebkitTextFillColor: "#FFC233", border: 0 }} data-testid="aside-newsletter-submit">
            {status === "sending" ? "Iscrivo…" : "Iscrivimi e scarica"}
          </button>
        </form>
      )}
      <span className="text-[12px]" style={{ color: "#111318" }}>{count != null ? `${count.toLocaleString("it-IT")} iscritti` : "Quasi 7.000 iscritti"} · zero spam · GDPR</span>
    </div>
  );
}

// ─── HostClub ───
function HostClub() {
  const [members, setMembers] = useState(null);
  useEffect(() => {
    let alive = true;
    fetch(`${API}/hostclub/public-stats`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (alive && d && typeof d.total_members === "number") setMembers(d.total_members); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);
  const YELLOW = "#F7CD46";
  const SERIF = "'Instrument Serif', Georgia, serif";
  const count = members || 0;
  const nextNumber = count + 1;
  const rollStart = Math.max(1, nextNumber - 14);
  const rollNums = [];
  for (let n = rollStart; n <= nextNumber; n++) rollNums.push(n);
  const rollDist = -(rollNums.length - 1) * 50;
  return (
    <div className="rounded-[20px] relative overflow-hidden flex flex-col" style={{ background: "#0A090C", color: "#FFFFFF", padding: 22 }} data-testid="aside-hostclub">
      {/* texture + bagliore unico dietro a tutta la card (clip solo sugli angoli) */}
      <div aria-hidden="true" style={{ position: "absolute", inset: 0, opacity: 0.07, backgroundImage: "radial-gradient(#ffffff 1px, transparent 1.3px)", backgroundSize: "16px 16px", pointerEvents: "none" }} />
      <div aria-hidden="true" style={{ position: "absolute", left: "50%", top: "44%", width: 440, height: 520, transform: "translate(-50%,-50%)", borderRadius: "50%", background: "radial-gradient(circle, rgba(247,205,70,.20), rgba(247,205,70,.07) 46%, transparent 70%)", filter: "blur(12px)", pointerEvents: "none" }} />

      <div style={{ position: "relative", width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
        <div style={{ fontFamily: BRIC, fontWeight: 800, fontSize: 18, lineHeight: 1.0, letterSpacing: "-.045em", textAlign: "center", padding: "0 6px", width: "100%" }}>
          In 2 minuti potresti essere<br />
          <span style={{ fontFamily: SERIF, fontStyle: "italic", fontWeight: 400, color: YELLOW, fontSize: "1.18em" }}>la tessera numero:</span>
        </div>
        <div style={{ height: 158, marginTop: 26, display: "flex", alignItems: "center", justifyContent: "center", width: "100%" }}>
          <div style={{ transform: "scale(.80)", transformOrigin: "center" }}>
            <div aria-hidden="true" style={{ width: 300, height: 188, perspective: "1100px", animation: "hpFloatY 5s ease-in-out infinite" }}>
              <div style={{ position: "relative", width: "100%", height: "100%", transformStyle: "preserve-3d", animation: "hpSpin 7s cubic-bezier(.5,0,.85,.12) infinite" }}>
                {/* FRONT */}
                <div style={{ position: "absolute", inset: 0, borderRadius: 22, background: "linear-gradient(135deg, #1F1924, #2E2535)", border: `2px solid ${YELLOW}`, boxShadow: "0 0 56px rgba(247,205,70,.45), 0 36px 50px -20px rgba(0,0,0,.9)", padding: "22px 24px", boxSizing: "border-box", textAlign: "left", backfaceVisibility: "hidden", WebkitBackfaceVisibility: "hidden", overflow: "hidden" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <div style={{ fontFamily: BRIC, fontWeight: 800, fontSize: 26, letterSpacing: "-.02em", color: YELLOW, textTransform: "uppercase" }}>Host<span style={{ color: "#FF4FCF" }}>Club</span></div>
                    <div style={{ width: 40, height: 29, borderRadius: 7, background: "linear-gradient(135deg, #F7CD46, #C99A1E)" }} />
                  </div>
                  <div style={{ fontSize: 11, letterSpacing: ".16em", textTransform: "uppercase", color: "#B9B2BE", marginTop: 34, fontWeight: 700 }}>Tessera numero</div>
                  <div style={{ display: "flex", alignItems: "flex-end", fontFamily: BRIC, fontWeight: 800, fontSize: 46, letterSpacing: "-.04em", fontVariantNumeric: "tabular-nums" }}>
                    <div style={{ height: 50, overflow: "hidden", textAlign: "right" }}>
                      {count > 0 && rollNums.length > 1 ? (
                        <div style={{ "--roll": `${rollDist}px`, animation: "hpRoll 2.4s cubic-bezier(.12,.8,.2,1) .5s both" }}>
                          {rollNums.map((n) => <div key={n} style={{ height: 50, lineHeight: "50px", textAlign: "right" }}>{n}</div>)}
                        </div>
                      ) : (
                        <div style={{ height: 50, lineHeight: "50px", textAlign: "right" }}>{nextNumber}</div>
                      )}
                    </div>
                    <span style={{ color: YELLOW, lineHeight: "50px" }}>.</span>
                  </div>
                  <img src={LOGO_URL} alt="Vita da Host" style={{ position: "absolute", right: 16, bottom: 14, width: "28%", height: "auto", opacity: 0.95 }} />
                  <div style={{ position: "absolute", top: 0, left: 0, width: "45%", height: "100%", background: "linear-gradient(105deg, transparent 20%, rgba(255,255,255,.5), transparent 80%)", animation: "hpShine 7s ease-in-out infinite", pointerEvents: "none" }} />
                </div>
                {/* BACK */}
                <div style={{ position: "absolute", inset: 0, borderRadius: 22, background: "linear-gradient(135deg, #2E2535, #1F1924)", border: `2px solid ${YELLOW}`, boxShadow: "0 0 56px rgba(247,205,70,.45), 0 36px 50px -20px rgba(0,0,0,.9)", display: "flex", alignItems: "center", justifyContent: "center", backfaceVisibility: "hidden", WebkitBackfaceVisibility: "hidden", transform: "rotateY(180deg)" }}>
                  <img src={LOGO_URL} alt="" style={{ width: "56%", height: "auto", opacity: 0.95 }} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <span className="text-[14px]" style={{ display: "block", textAlign: "center", fontWeight: 700, lineHeight: 1.3, color: "#D3D7DE", marginTop: 26 }}>Il <span style={{ color: "#FF4FCF" }}>Club</span> privato degli Host e PM che fanno sul serio. Strumenti, consulenze e una linea diretta con il <span style={{ color: "#FF4FCF" }}>Team di Vita da Host</span>.</span>
        <Link to="/hostclub" className="w-full h-12 rounded-[12px] flex items-center justify-center font-extrabold" style={{ background: YELLOW, color: "#17131B", marginTop: 22 }} data-testid="aside-hostclub-join">Iscriviti · 19,90€/anno</Link>
        <Link to="/hostclub/login" className="text-[14px] text-center underline" style={{ color: "#FFFFFF", marginTop: 12 }} data-testid="aside-hostclub-login">Sei già socio? Entra</Link>
      </div>
    </div>
  );
}

// ─── Le nostre app ───
const APPS = [
  ["App Vita da Host", "Webapp gratuita", "/servizi/app-ufficiali"],
  ["LocazioneTuristica", "Tool per host privati", "/servizi/lt"],
  ["Hostland", "Sito e guestbook", "/hostland"],
  ["HostMarket", "Marketplace dei pro", "/servizi/hostmarket"],
  ["WCity", "Bagni pubblici", "/tools/bagni-pubblici"],
  ["QuantoGuadagni?", "Netto Airbnb e Booking", "/calcolatoreguadagniaffittibrevi"],
  ["Radar dei vettori", "Voli e traghetti", "/radar"],
  ["Cody", "Generatore QR", "/qrcodegratis"],
  ["PhotoBoost", "Foto per gli annunci", "/servizi/photoboost"],
  ["CalculHost", "Imposta di soggiorno", "/strumenti/calcolo-imposta-soggiorno"],
];
function LeNostreApp() {
  return (
    <Box title="Le nostre app" data-testid="aside-apps">
      <div className="grid grid-cols-2 gap-2">
        {APPS.map(([name, sub, to]) => (
          <SmartLink key={name} to={to} className="flex flex-col gap-0.5 rounded-[12px] p-2.5" style={{ background: "#F6F7F9" }}>
            <strong className="text-[14px]" style={{ color: "#111318" }}>{name}</strong>
            <span className="text-[12px]" style={{ color: "#4A505B" }}>{sub}</span>
          </SmartLink>
        ))}
      </div>
    </Box>
  );
}

// ─── Editoriale Scelto ───
function EditorialeScelto() {
  return (
    <div className="rounded-[20px] p-5 flex flex-col gap-2" style={{ background: "#FFF8E6", border: "1px solid #F0D58A" }} data-testid="aside-editoriale-scelto">
      <span className="text-[12px] font-extrabold" style={{ color: "#6B4100" }}>EDITORIALE · CONTEST</span>
      <strong className="text-[17px]" style={{ color: "#111318" }}>Scelto da Vita da Host</strong>
      <span className="text-[14px]" style={{ color: "#4A505B" }}>Le strutture testate e approvate. Candida la tua e porta la tua struttura sulla mappa.</span>
      <Link to="/servizi/scelto-da-vita-da-host#candidati" className="h-12 mt-1 rounded-[12px] flex items-center justify-center gap-2 font-extrabold text-[15px] transition-transform hover:scale-[1.01]" style={{ background: "#DC2626", color: "#FFFFFF", WebkitTextFillColor: "#FFFFFF" }} data-testid="aside-editoriale-scelto-cta">
        Candidati gratis →
      </Link>
    </div>
  );
}

// ─── Più letti del blog ───
function PiuLetti() {
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    let alive = true;
    axios.get(`${API}/blog-news/top?limit=3`).then((r) => { if (alive) setPosts(r.data?.items || []); }).catch(() => {});
    return () => { alive = false; };
  }, []);
  if (!posts.length) return null;
  return (
    <Box title="Più letti del blog" data-testid="aside-piu-letti">
      {posts.map((p, i) => (
        <Link key={p.slug || i} to={`/blog/${p.slug}`} className="flex gap-2.5">
          <strong style={{ fontFamily: BRIC, fontSize: 22, color: "#C2410C" }}>{i + 1}</strong>
          <span className="flex flex-col">
            <span className="text-[14px] font-semibold" style={{ lineHeight: 1.35, color: "#111318" }}>{p.title}</span>
            {Number(p.internal_clicks || 0) > 0 && <span className="text-[12px]" style={{ color: "#5B616C" }}>{p.internal_clicks} letture</span>}
          </span>
        </Link>
      ))}
    </Box>
  );
}

// ─── Bestseller del negozio ───
function Bestseller() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const best = await axios.get(`${API}/printful/sync/bestsellers?days=30&limit=3`);
        const ids = best.data?.ids || [];
        const all = await axios.get(`${API}/printful/sync/products`);
        let list = (all.data?.items || []).filter((p) => ids.includes(Number(p.id)));
        list.sort((a, b) => ids.indexOf(Number(a.id)) - ids.indexOf(Number(b.id)));
        if (!list.length) list = (all.data?.items || []).slice(0, 3);
        if (alive) setItems(list.slice(0, 3));
      } catch { /* silent */ }
    })();
    return () => { alive = false; };
  }, []);
  return (
    <Box title="Bestseller del negozio" headerRight={<Link to="/negozio" className="text-[14px] font-bold" style={{ color: "#111318" }}>Negozio →</Link>} data-testid="aside-bestseller">
      {(items.length ? items : []).map((p, i) => (
        <Link key={p.id} to={`/negozio/printful/prodotto/${p.id}`} className="text-[14px]" style={{ color: "#111318" }}>{i + 1}. {p.name}</Link>
      ))}
      {!items.length && <span className="text-[14px]" style={{ color: "#4A505B" }}>Apri il negozio per i più venduti →</span>}
    </Box>
  );
}

// ─── Community e offerte ───
function CommunityOfferte() {
  return (
    <Box title="Community e offerte" data-testid="aside-community-offerte">
      <a href="https://t.me/vitadahost" target="_blank" rel="noopener noreferrer" className="flex justify-between rounded-[12px] p-3 font-semibold text-[14px]" style={{ background: "#F6F7F9", color: "#111318" }}>Gruppo Telegram Vita da Host <span>→</span></a>
      <Link to="/hostclub" className="flex justify-between rounded-[12px] p-3 font-semibold text-[14px]" style={{ background: "#F6F7F9", color: "#111318" }}>Canale HostClub (soci) <span>→</span></Link>
      <span className="text-[13px] mt-1" style={{ color: "#4A505B" }}>Canali offerte</span>
      <div className="flex gap-2">
        <a href="https://t.me/offertedahost" target="_blank" rel="noopener noreferrer" className="flex-1 text-center rounded-[10px] py-2.5 text-[13px] font-bold" style={{ border: "1px solid #D5D8DE", color: "#111318" }}>Telegram</a>
        <a href="https://www.instagram.com/channel/AbZxB-RI-kxiLU7n/" target="_blank" rel="noopener noreferrer" className="flex-1 text-center rounded-[10px] py-2.5 text-[13px] font-bold" style={{ border: "1px solid #D5D8DE", color: "#111318" }}>Instagram</a>
        <a href="https://whatsapp.com/channel/0029Vb6Htxo0rGiOtmI4g02g" target="_blank" rel="noopener noreferrer" className="flex-1 text-center rounded-[10px] py-2.5 text-[13px] font-bold" style={{ border: "1px solid #D5D8DE", color: "#111318" }}>WhatsApp</a>
      </div>
    </Box>
  );
}

// ─── Associazioni ───
function Associazioni() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    let alive = true;
    axios.get(`${API}/associazioni/list`, { params: { limit: 3 } }).then((r) => { if (alive) setItems(r.data?.items || []); }).catch(() => {});
    return () => { alive = false; };
  }, []);
  return (
    <Box title="Associazioni di host" headerRight={<Link to="/servizi/associazioni" className="text-[14px] font-bold" style={{ color: "#111318" }}>Mappa →</Link>} data-testid="aside-associazioni">
      {items.map((it) => (
        <Link key={it.id} to={`/servizi/associazioni/${it.slug || it.id}`} className="text-[14px]" style={{ color: "#111318" }}>
          <strong>{it.name}</strong>{it.comune ? ` · ${it.comune}` : ""}
        </Link>
      ))}
      {!items.length && <span className="text-[14px]" style={{ color: "#4A505B" }}>Sii la prima associazione sulla mappa →</span>}
    </Box>
  );
}

// ─── Sponsor colonna ───
function SponsorColonna() {
  return (
    <Box title="Sponsor" data-testid="aside-sponsor">
      <SponsorBanner placement="sidebar" />
      <Link to="/contatti/collabora" className="text-[13px]" style={{ color: "#4A505B" }}>Vuoi mettere qui la pubblicità?</Link>
    </Box>
  );
}

// ─── Seguici ───
const SOCIAL_META = [
  ["instagram", "Instagram", "https://www.instagram.com/vita_da_host_/", "58K"],
  ["facebook", "Facebook", "https://www.facebook.com/VitadaHostUfficiale/", "15,1K"],
  ["threads", "Threads", "https://www.threads.com/@vita_da_host_", "3,2K"],
  ["tiktok", "TikTok", "https://www.tiktok.com/@vita.da.host", "2,8K"],
  ["linkedin", "LinkedIn", "https://www.linkedin.com/in/sergio-battelli-vitadahost/", "977"],
  ["youtube", "YouTube", "https://youtube.com/@vitadahostchannel", "555"],
];
function fmtK(n) {
  if (typeof n !== "number") return null;
  if (n >= 1000) return `${(n / 1000).toFixed(n % 1000 === 0 ? 0 : 1).replace(".", ",")}K`;
  return String(n);
}
function Seguici() {
  const [counts, setCounts] = useState(null);
  useEffect(() => {
    let alive = true;
    fetch(`${API}/social-followers`).then((r) => r.json()).then((d) => { if (alive) setCounts(d?.counts || d || null); }).catch(() => {});
    return () => { alive = false; };
  }, []);
  return (
    <Box title="Seguici" data-testid="aside-seguici">
      <div className="grid grid-cols-3 gap-2 text-[13px]">
        {SOCIAL_META.map(([key, label, url, fallback]) => {
          const live = counts && typeof counts[key] === "number" ? fmtK(counts[key]) : null;
          return (
            <a key={key} href={url} target="_blank" rel="noopener noreferrer" aria-label={`${label}: ${live || fallback} follower`}
              className="flex flex-col items-center rounded-[10px] p-2.5" style={{ background: "#F6F7F9", color: "#111318" }}>
              <strong className="text-[16px]">{live || fallback}</strong>
              <span>{label}</span>
            </a>
          );
        })}
      </div>
    </Box>
  );
}

export default function HomeAside() {
  return (
    <aside className="flex flex-col gap-[18px] min-w-0" style={{ flex: "1 1 320px" }} aria-label="Approfondimenti e community" data-testid="home-aside">
      <HostClub />
      <AppUfficiale />
      <ProssimiEventi />
      <NewsletterFaqBnb />
      <LeNostreApp />
      <EditorialeScelto />
      <PiuLetti />
      <Bestseller />
      <CommunityOfferte />
      <Associazioni />
      <SponsorColonna />
      <Seguici />
    </aside>
  );
}

export { HostClub as HostClubCard };
